import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/site-data";

export default function Testimonials() {
  return (
    <section className="py-20 md:py-28 bg-brand-muted/60" data-testid="testimonials-section">
      <div className="container-site">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <p className="overline mb-3">What Pune & PCMC says about us</p>
            <h2 className="font-serif text-4xl md:text-5xl text-brand-pine leading-tight">
              Trusted by <span className="italic text-brand-clay">your neighbours.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="bg-white rounded-2xl p-7 md:p-8 border border-brand-line/60 hover:shadow-md transition-shadow relative"
            >
              <Quote size={30} className="text-brand-clay/30 mb-3" />
              <p className="text-brand-text leading-relaxed text-[17px]">{t.text}</p>
              <div className="mt-6 flex items-center justify-between">
                <div>
                  <p className="font-serif text-lg text-brand-pine">{t.name}</p>
                  <p className="text-xs text-brand-textMuted">{t.area}, Pune</p>
                </div>
                <div className="flex">
                  {Array.from({ length: t.stars }).map((_, j) => (
                    <Star key={j} size={14} className="fill-brand-clay text-brand-clay" />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
